import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { ShipmentsDetailsData } from 'models/Shipments';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { RowItems } from '../../models/TableProps';
import { formatPrice } from '../../utils/numberFormatter';

export const ShipmentLabelProductsTableRow: React.FC<
    RowItems<ShipmentsDetailsData>
> = (props) => {
    const { row, index } = props;
    const { t } = useTranslation('shipments', {
        keyPrefix: 'SHIPMENT_DETAILS',
    });
    const labelId = `enhanced-table-checkbox-${index}`;

    return (
        <TableRow tabIndex={-1} hover key={index}>
            <TableCell id={labelId}>{row.lineObjectNumber}</TableCell>
            <TableCell>{row.description}</TableCell>
            <TableCell>
                {row.quantity} {t('QUANTITY_UNITS')}
            </TableCell>
            <TableCell>{formatPrice(row.unitPrice)} Ft</TableCell>
            <TableCell>{row.taxPercent} %</TableCell>
            <TableCell>{row.discountPercent} %</TableCell>
            <TableCell>{row.shipmentDate}</TableCell>
        </TableRow>
    );
};
